import React, { memo, useContext, useMemo } from "react";
import { WidgetControllerContext } from "@swiggy-private/dls-react-mxn/dist";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { ResponseContext, ScreenNames } from "@swiggy-private/portal-dineout-context";
import { BottomWidget, Container, FlexContainer, PendingAndErrorHeaderContainer } from "./styles";
import { BillSummaryType } from "./types";
import { BILL_SUMMARY_PENDING_SCREEN_HEADER } from "../constants/track";
import { useAnalytics } from "../hooks";
import { PLWidgetRenderer } from "../PLWidgetRenderer";

const BillPending: React.FC<BillSummaryType> = ({
    headers,
    sdk,
    clickAnalytics: defaultClickAnalytics,
    impressionAnalytics: defaultImpressionAnalytics,
    genericOnclick,
    onInvalidWidget,
    onWidgetError,
    onEmptyPage,
    screenName,
    popupConfigs,
}) => {
    const { state } = useContext(ResponseContext);
    const { impressionAnalytics, clickAnalytics } = useAnalytics({
        screenName: ScreenNames.BILL_SUMMARY,
        defaultImpressionAnalytics,
        defaultClickAnalytics,
    });

    const contextValue = useMemo(() => {
        return {
            sdk,
            impressionAnalytics,
            clickAnalytics,
            headers,
            clickHandler: genericOnclick,
        };
    }, [clickAnalytics, genericOnclick, headers, impressionAnalytics, sdk]);
    return (
        <Container>
            <PendingAndErrorHeaderContainer>
                <Text
                    variant="V2.body2.neutral.bold"
                    textAlign="center"
                    color="text_Highest_Emphasis"
                    as="span"
                >
                    {BILL_SUMMARY_PENDING_SCREEN_HEADER}
                </Text>
            </PendingAndErrorHeaderContainer>
            <FlexContainer>
                <WidgetControllerContext.Provider value={contextValue}>
                    <PLWidgetRenderer
                        onInvalidWidget={onInvalidWidget}
                        onWidgetError={onWidgetError}
                        onEmptyPage={onEmptyPage}
                        cards={state.billSummary?.data?.success?.cards || []}
                        popupConfigs={popupConfigs}
                        screenName={screenName}
                    />
                </WidgetControllerContext.Provider>
                <BottomWidget />
            </FlexContainer>
        </Container>
    );
};

export default memo(BillPending);
